import {createSharedValueKey, DefaultSharedStore, SharedValueStoreContext} from '@epic-core/hooks';
import {AppSharedKeys, getSharedContext, setSharedContext} from 'epic-ue-shared';
import {AltAppConfig} from './shared';

export const sharedStore = new DefaultSharedStore();

export async function bootstrapSharedValues(altAppConfig: AltAppConfig): Promise<void> {
    let context = getSharedContext();
    const stores = Object.keys(AppSharedKeys) || [];
    context = new SharedValueStoreContext(sharedStore);

    stores.forEach((store) => {
        AppSharedKeys[store] = createSharedValueKey(store, altAppConfig[store] || {});
        context.set(AppSharedKeys[store], altAppConfig[store] || {});
    });

    setSharedContext(context);
}

export const useClientData = (): void => {};
